"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'LINK';
class LinkNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const { recordId } = params;
            const { recordType, customPage = '', pageType } = this.config;
            const buildLink = () => {
                switch (pageType) {
                    case 'Selected Record View':
                        return recordId && recordType ? `/${recordType}/${recordId}` : '';
                    case 'Custom Page':
                        if (recordType === 'Ad Hoc' || !recordType)
                            return `/page/${customPage}`;
                        return recordId ? `/page/${customPage}/${recordId}` : `/page/${customPage}`;
                    case 'Detail Page':
                    default:
                        return recordId && recordType ? `/${recordType}/${recordId}/edit` : '';
                }
            };
            return { link: buildLink() };
        };
        this._interfaceDefinition = Schema;
    }
    get interfaceDefinition() {
        return Object.assign(Object.assign({}, Schema), { InputParams: this._interfaceDefinition.definitions.InputParams, OutputParams: this._interfaceDefinition.definitions.OutputParams, ConfigParams: this.getConfigSchema() });
    }
    getConfigSchema() {
        const aggregateTypes = this.schemaLookup.getAggregates() || [];
        const { pageType, recordType } = this.config;
        const baseSchema = {
            type: 'object',
            properties: {
                pageType: {
                    description: 'Page Type',
                    enum: ['Custom Page', 'Detail Page', 'Selected Record View'],
                    type: 'string',
                    default: 'Detail Page',
                },
                recordType: {
                    description: 'Record Type',
                    type: 'string',
                    enum: pageType === 'Custom Page' ? [...aggregateTypes, 'Ad Hoc'] : [...aggregateTypes],
                    default: pageType === 'Detail Page' || !pageType ? undefined : 'Ad Hoc',
                },
            },
        };
        if (pageType === 'Custom Page') {
            baseSchema.properties['customPage'] = {
                type: 'string',
                description: 'Custom Page',
                enum: this.schemaLookup.getCustomPages(recordType),
            };
        }
        return baseSchema;
    }
}
exports.LinkNode = LinkNode;
LinkNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Link',
    isIdempotent: true,
    primaryCategory: 'Data Lookup',
};
//# sourceMappingURL=Link.js.map